import { makeStyles } from '@mui/styles';

const useAGWRangesTableStyles = makeStyles({
	container: {
		overflowX: 'auto',
		width: '100%',
		scrollbarColor: '#c7c7c7 #E9E9E9',
		scrollbarWidth: 'thin',
		'&::-webkit-scrollbar': {
			height: 6,
		},
		'&::-webkit-scrollbar-track': {
			backgroundColor: '#E9E9E9',
			borderRadius: 7,
		},
		'&::-webkit-scrollbar-thumb': {
			backgroundColor: '#c7c7c7',
			borderRadius: 7,
		},
	},
	root: {
		fontFamily: 'Montserrat',
		fontSize: 14,
		'& thead, & tbody, & tr': {
			display: 'table',
			tableLayout: 'fixed',
			width: '100%',
		},
		'& thead': {
			width: 'calc(100% - 6px)',
			'& > tr': {
				paddingLeft: 7,
				'&:nth-child(1) > th': {
					fontWeight: 500,
					textAlign: 'left',
				},
			},
		},
		'& tbody': {
			display: 'block',
			maxHeight: 123,
			overflowX: 'hidden',
			overflowY: 'auto',
			scrollbarColor: '#1063AC #E9E9E9',
			scrollbarWidth: 'thin',
			'&::-webkit-scrollbar': {
				width: '6px',
				background: '#6868681A',
				borderRadius: 7,
			},
			'&::-webkit-scrollbar-thumb': {
				background: '#68686880',
				borderRadius: 7,
			},
			'& > tr': {
				borderRadius: 8,
				paddingLeft: 7,
			},
		},
		'& th': {
			color: '#003C82',
			fontWeight: 600,
			textAlign: 'left',
		},
		'& td': {
			color: '#1A1233',
			padding: '3px 0',
			'&:nth-child(1)': {
				fontWeight: 600,
			},
		},
	},
});

export default useAGWRangesTableStyles;
